// import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useCart } from "../../context/CartContext";
import "./index.css";

const ShoppingCart = () => {
  const navigate = useNavigate();
  const {
    cartItems,
    removeFromCart,
    updateQuantity,
    // couponCode,
    couponApplied,
    discountPercent,
    // applyCoupon,
    // removeCoupon,
    calculateSubtotal,
    calculateDiscount
  } = useCart();

  const userState = ""; // Static state set to Punjab
  // const [tempCouponCode, setTempCouponCode] = useState("");
  // const [couponMessage, setCouponMessage] = useState("");
  // const [showCouponInput, setShowCouponInput] = useState(!couponApplied);

  // Handle remove product
  const handleRemoveProduct = (productId) => {
    removeFromCart(productId);
  };

  // Handle increase quantity
  const handleIncreaseQuantity = (productId, currentQuantity) => {
    updateQuantity(productId, currentQuantity + 1);
  };

  // Handle decrease quantity
  const handleDecreaseQuantity = (productId, currentQuantity) => {
    if (currentQuantity > 1) {
      updateQuantity(productId, currentQuantity - 1);
    } else {
      removeFromCart(productId);
    }
  };

  // Calculate original subtotal (before discount)
  const originalSubtotal = calculateSubtotal();

  // Total discount amount
  const totalDiscountAmount = calculateDiscount();

  // Calculate the subtotal (after discount)
  const subtotal = originalSubtotal - totalDiscountAmount;

  // Handle apply coupon
  // const handleApplyCoupon = () => {
  //   if (!showCouponInput) {
  //     setShowCouponInput(true);
  //   } else {
  //     if (tempCouponCode.trim() === "") {
  //       setCouponMessage("Please enter a valid coupon code");
  //       return;
  //     }

  //     const result = applyCoupon(tempCouponCode);
  //     if (result.success) {
  //       setCouponMessage("");
  //       setShowCouponInput(false);
  //     } else {
  //       setCouponMessage(result.message);
  //     }
  //   }
  // };

  // Handle remove coupon
  // const handleRemoveCoupon = () => {
  //   removeCoupon();
  //   setTempCouponCode("");
  //   setShowCouponInput(true);
  // };

  // Calculate taxes based on user's state (tax is inclusive in the subtotal)
const calculateTaxes = () => {
  const taxRate = 0.05; // 5% GST

  // Calculate taxable amount (subtotal divided by 1 + tax rate)
  const taxableAmount = subtotal / (1 + taxRate);

  // Calculate tax amount (subtotal minus taxable amount)
  const taxAmount = subtotal - taxableAmount;

  if (userState === "maharashtra") {
    // Maharashtra: Split into SGST and CGST (2.5% each)
    return {
      taxableAmount: taxableAmount,
      sgst: taxAmount / 2,
      cgst: taxAmount / 2,
      igst: 0,
      total: taxAmount,
    };
  } else {
    // Other states: Apply IGST (5%)
    return {
      taxableAmount: taxableAmount,
      sgst: 0,
      cgst: 0,
      igst: taxAmount,
      total: taxAmount,
    };
  }
};

const taxes = calculateTaxes();

// Shipping logic:
// If subtotal >= 599 → FREE, else charge ₹599
const shipping = subtotal >= 599 ? 0 : 99;

// Grand total = subtotal + shipping
const grandTotal = subtotal + shipping;

  return (
    <>
      <div className="cart-con position-relative">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-12">
              <div className="product-detail-box" data-aos="fade-up">
                <div className="heading">
                  <span>Shopping Cart</span>
                  <span>({cartItems.length} Items)</span>
                </div>
                <div className="shopping-cart">
                  <div className="column-labels">
                    <label className="product-details">Product Details</label>
                    <label className="product-price">Price</label>
                    <label className="product-quantity">Quantity</label>
                    <label className="product-line-price">Total</label>
                    <label className="product-removal"></label>
                  </div>
                  <div className="shopping-cart-info">
                    {cartItems.length > 0 ? (
                      cartItems.map((item) => {
                        const itemId = item.productId;
                        const itemPrice = item.productUnitPrice || item.price || 0;
                        const itemImage = item.productImage || item.image || "/placeholder.svg";
                        const itemName = item.productName || item.name || "Product";
                        return (
                          <div key={itemId} className="product d-sm-flex d-block align-items-center">
                            <div className="product-details">
                              <div className="product-image box1">
                                <figure className="mb-0">
                                  <img src={itemImage || "/placeholder.svg"} alt={itemName} className="img-fluid" />
                                </figure>
                              </div>
                              <div className="product-content">
                                <span className="product-title">
                                  {itemName.slice(0, 15)}{itemName.length > 15 && '...'}
                                </span>
                              </div>

                            </div>
                            <div className="product-price">
                              {couponApplied ? (
                                <div className="price-with-discount">
                                  <div className="original-price">₹{itemPrice.toFixed(2)}</div>
                                </div>
                              ) : (
                                <span>₹{itemPrice.toFixed(2)}</span>
                              )}
                            </div>
                            <div className="product-quantity d-flex">
                              <div className="product-qty-details">
                                <button
                                  className="value-button decrease-button"
                                  onClick={() => handleDecreaseQuantity(itemId, item.quantity)}
                                  title=""
                                >
                                  -
                                </button>
                                <div className="number">{item.quantity}</div>
                                <button
                                  className="value-button increase-button"
                                  onClick={() => handleIncreaseQuantity(itemId, item.quantity)}
                                  title=""
                                >
                                  +
                                </button>
                              </div>
                            </div>
                            <div className="product-line-price">
                              {couponApplied ? (
                                <div className="total-with-discount">
                                  <div className="original-total">₹{(itemPrice * item.quantity).toFixed(2)}</div>
                                </div>
                              ) : (
                                <span>₹{(itemPrice * item.quantity).toFixed(2)}</span>
                              )}
                            </div>
                            <div className="product-removal">
                              <button className="remove-product" onClick={() => handleRemoveProduct(itemId)}>
                                <i className="fas fa-times"></i>
                              </button>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="empty-cart-message text-center py-5">
                        <div className="empty-cart-icon mb-3">
                          <i className="fas fa-shopping-cart fa-4x text-muted"></i>
                        </div>
                        <h4>Your cart is empty</h4>
                        <p className="text-muted">Looks like you haven't added any items to your cart yet.</p>
                      </div>
                    )}
                  </div>
                </div>
                {cartItems.length > 0 && (
                  <div className="buttun-shopping">
                    <span
                      onClick={() => navigate(-1)}
                      className="text-decoration-none"
                      style={{ cursor: 'pointer', color: 'inherit' }}>
                      <i className="fa-solid fa-arrow-left"></i> Continue Shopping
                    </span>
                  </div>
                )}
              </div>
            </div>

            <div className="col-lg-4 col-12">
              <div className="heading" style={{ marginBottom: "15px" }}>
                <span
                  style={{
                    fontWeight: "700",
                    fontSize: "18px",
                    paddingLeft: "2vw",
                    display: "block",
                    lineHeight: "normal",
                  }}
                >
                  Order Summary
                </span>
              </div>
              <div className="cart-total-outer" data-aos="fade-up" style={{ marginBottom: "50px", marginTop: "15px" }}>
                {cartItems.length > 0 ? (
                  <>
                    {/* {couponApplied ? (
                      <div
                        style={{
                          backgroundColor: "#f0f9f0",
                          border: "1px solid #dcedc8",
                          padding: "10px 15px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "15px",
                          borderTopLeftRadius: "17px",
                          borderTopRightRadius: "17px",
                        }}
                      >
                        <span style={{ color: "#388e3c", fontWeight: "500" }}>
                          Coupon applied: {couponCode} ({discountPercent}% off)
                        </span>
                        <button
                          onClick={handleRemoveCoupon}
                          style={{
                            backgroundColor: "#dc3545",
                            color: "white",
                            border: "none",
                            cursor: "pointer",
                            padding: "8px 16px",
                            borderRadius: "50px",
                            marginLeft: "10px",
                            fontSize: "12px",
                            lineHeight: "12px",
                            fontWeight: "600",
                          }}
                        >
                          Remove
                        </button>
                      </div>
                    ) : (
                      <div
                        className="coupon"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginBottom: "15px",
                        }}
                      >
                        <div className="ticket" style={{ display: "flex", alignItems: "center", flex: 1 }}>
                          {!showCouponInput && <i className="fa-solid fa-ticket"></i>}
                          {showCouponInput ? (
                            <input
                              type="text"
                              placeholder="Enter coupon code"
                              value={tempCouponCode}
                              onChange={(e) => setTempCouponCode(e.target.value)}
                              style={{
                                marginLeft: "5px",
                                padding: "8px 10px",
                                flex: 1,
                                borderRadius: "40px",
                                border: "1px solid #ddd",
                                width: "100%",
                              }}
                            />
                          ) : (
                            <span className="heading">Apply Coupons</span>
                          )}
                        </div>
                        <a
                          href="/"
                          onClick={(e) => {
                            e.preventDefault();
                            handleApplyCoupon();
                          }}
                          className="text-decoration-none"
                          style={{
                            background: "#6f42c1",
                            color: "white",
                            padding: "8px 16px",
                            borderRadius: "50px",
                            marginLeft: "10px",
                            display: "inline-block",
                          }}
                        >
                          Apply
                        </a>
                      </div>
                    )}
                    {couponMessage && (
                      <div style={{ color: "#d32f2f", fontSize: "14px", marginBottom: "10px", textAlign: "center" }}>
                        {couponMessage}
                      </div>
                    )} */}
                    <div className="detail">
                      <span className="heading">Product Details:</span>
                      <ul className="list-unstyled mb-0">
                        {/* Show discount if applied */}
                        {couponApplied && (
                          <>
                            <li>
                              <span>Original Price</span>
                              <span className="dollar">₹{originalSubtotal.toFixed(2)}</span>
                            </li>
                            <li>
                              <span>Discount ({discountPercent}%)</span>
                              <span className="dollar" style={{ color: "#388e3c" }}>
                                -₹{totalDiscountAmount.toFixed(2)}
                              </span>
                            </li>
                          </>
                        )}

                        {/* Subtotal (after discount) */}
                        <li className="subtotal-line">
                          <span>Subtotal</span>
                          <span className="dollar">₹{subtotal.toFixed(2)}</span>
                        </li>

                        {/* Tax breakdown section */}
                        <li className="tax-section">
                          <span style={{ fontWeight: "600" }}>Tax Breakdown (Inclusive)</span>
                          <span></span>
                        </li>

                        <li className="tax-item">
                          <span>Taxable Amount</span>
                          <span className="dollar">₹{taxes.taxableAmount.toFixed(2)}</span>
                        </li>

                        {/* Tax details based on state */}
                        {userState === "maharashtra" ? (
                          <>
                            <li className="tax-item">
                              <span>SGST (2.5%)</span>
                              <span className="dollar">₹{taxes.sgst.toFixed(2)}</span>
                            </li>
                            <li className="tax-item">
                              <span>CGST (2.5%)</span>
                              <span className="dollar">₹{taxes.cgst.toFixed(2)}</span>
                            </li>
                          </>
                        ) : (
                          <li className="tax-item">
                            <span>IGST (5%)</span>
                            <span className="dollar">₹{taxes.igst.toFixed(2)}</span>
                          </li>
                        )}

                        <li>
                          <span>Shipping</span>
                          <span className="dollar">₹{shipping.toFixed(2)}</span>
                        </li>
                      </ul>
                      <div className="all-total">
                        <div className="total">
                          <span className="text">Order Total</span>
                          <span className="dollar">₹{grandTotal.toFixed(2)}</span>
                        </div>
                        <a href="/checkout" className="text-decoration-none all_button">
                          Proceed to checkout<i className="fa-solid fa-arrow-right"></i>
                        </a>
                      </div>
                      <div className="note">
                        <i className="fa-solid fa-shield-halved"></i>
                        <span className="note-text">Safe and Secure Payments, Easy Returns. 100% Authentic Products</span>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="detail empty-cart-summary">
                    <div className="text-center py-4">
                      <p className="mb-3">No items in your cart</p>
                      <p className="text-muted mb-4">Add items to your cart to see the order summary.</p>
                      <button
                        onClick={() => navigate('/')}
                        className="btn btn-primary"
                        style={{
                          background: "#6f42c1",
                          border: "none",
                          borderRadius: "50px",
                          padding: "10px 25px"
                        }}
                      >
                        Browse Products
                      </button>
                    </div>
                    <div className="note mt-4">
                      <i className="fa-solid fa-shield-halved"></i>
                      <span className="note-text">Safe and Secure Payments, Easy Returns. 100% Authentic Products</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShoppingCart;